import { OptimizelyDecision } from '@optimizely/react-sdk';
import events from './events';
import GROWTH_FULL_MEMBER_CUSTOMIZE_EXPERIMENT_1_0_0_VARIANTS from './experiments';
import track from './track';

const trackFMCOptimizelyExperiment = (
  decision: OptimizelyDecision, timerStatus: string, planCode: string,
) => {
  const experimentAttributes = {
    experiment_name: GROWTH_FULL_MEMBER_CUSTOMIZE_EXPERIMENT_1_0_0_VARIANTS.EXPERIMENT_NAME,
    variation_name: decision.variationKey as string,
    feature_flag_name: GROWTH_FULL_MEMBER_CUSTOMIZE_EXPERIMENT_1_0_0_VARIANTS.FEATURE_FLAG_NAME,
    timer: timerStatus, // 'active | expired'
    customize_experience_type: 'preview_customize',
    plan_code: planCode,
  };

  track(events.ORDER_MY_BOX, experimentAttributes);
};

export default trackFMCOptimizelyExperiment;
